import { IS_LOADING, SET_DATA_ID, SET_DATA_ITEM, SET_DATA_LIST, SET_ERROR, SET_SUCCESS, SET_TOTAL } from "@/store/Crud/functions/mutations";
export function SET_YOUTUBE_LINK(state, data) {
    state.pilotPraxisYoutubeLink = data;
}
export default {
    IS_LOADING,
    SET_ERROR,
    SET_SUCCESS,
    SET_DATA_ITEM,
    SET_DATA_LIST,
    SET_TOTAL,
    SET_DATA_ID,
    SET_YOUTUBE_LINK,
};
